import { useContext } from "react";
import { Card, Row, Col, Typography, Space, Tag } from "antd";
import { FaTicketAlt, FaTrophy } from "react-icons/fa";
import { IAward } from "../../../../../interfaces";
import { convertMoedaBRDoJSNovo, poeValorComPontosEmMil } from "../../../../../utils/Conversores";
import { ThemeContext } from "../../../../../contexts/ThemeContext";

const { Text } = Typography;

interface IProps {
    awards?: IAward[] | undefined;
    canViewWinners: boolean;
}

export const WinnersCard = ({ awards, canViewWinners }: IProps) => {
    const { theme } = useContext(ThemeContext);
    const isDark = theme === 'dark';

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            {awards?.map((award, idx) => {
                const { order, description, value, app_user } = award;
                return (
                    <Card
                        key={idx}
                        type="inner"
                        bordered={false}
                        className="report-card winners-card-item"
                        style={{
                            background: isDark ? '#1f1f1f' : '#f8fafc',
                            border: `1px solid ${isDark ? '#2d2d2d' : '#e2e8f0'}`,
                            borderRadius: 10,
                            marginBottom: 0,
                            boxShadow: 'none',
                        }}
                        headStyle={{
                            borderBottom: `1px solid ${isDark ? '#2d2d2d' : '#e2e8f0'}`,
                            padding: '10px 16px',
                        }}
                        bodyStyle={{
                            padding: '14px 16px',
                        }}
                        title={
                            <Row justify="space-between" align="middle" gutter={[8, 8]}>
                                <Col>
                                    <Space style={{ alignItems: 'center' }} wrap>
                                        <FaTrophy size={18} color="#eab308" />
                                        <Text strong className="section-title" style={{ color: isDark ? '#f1f5f9' : '#0f172a', fontSize: 14 }}>
                                            {order}º - {description}
                                        </Text>
                                        <Tag color="green" style={{ borderRadius: 6, fontWeight: 700, margin: 0 }}>
                                            R$ {convertMoedaBRDoJSNovo(value)}
                                        </Tag>
                                        {award.social_institution_value && Number(award.social_institution_value) > 0 ? (
                                            <Tag color="blue" style={{ borderRadius: 6, fontWeight: 700, margin: 0 }}>
                                                Inst. Social: R$ {convertMoedaBRDoJSNovo(award.social_institution_value)}
                                            </Tag>
                                        ) : null}
                                    </Space>
                                </Col>
                                <Col>
                                    <Space align="center" size={6}>
                                        <Text type="secondary" className="section-label" style={{ fontSize: 12, color: isDark ? '#94a3b8' : '#64748b' }}>
                                            Bilhete:
                                        </Text>
                                        <Tag
                                            color="blue"
                                            style={{
                                                fontSize: 13,
                                                fontWeight: 700,
                                                borderRadius: 6,
                                                margin: 0,
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                gap: 4
                                            }}
                                        >
                                            <FaTicketAlt size={11} />
                                            #{award.winning_ticket_id || '--'}
                                        </Tag>
                                    </Space>
                                </Col>
                            </Row>
                        }
                    >
                        {canViewWinners && app_user ? (
                            <Row gutter={[16, 10]}>
                                <Col xs={24} sm={12}>
                                    <div style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
                                        <Text type="secondary" className="section-label" style={{ fontSize: 12, color: isDark ? '#94a3b8' : '#64748b' }}>
                                            Ganhador:
                                        </Text>
                                        <Text className="section-text" strong style={{ color: isDark ? '#f1f5f9' : '#0f172a' }}>
                                            {app_user.name}
                                        </Text>
                                    </div>
                                </Col>
                                <Col xs={24} sm={12}>
                                    <div style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
                                        <Text type="secondary" className="section-label" style={{ fontSize: 12, color: isDark ? '#94a3b8' : '#64748b' }}>
                                            Total de Bilhetes:
                                        </Text>
                                        <Text className="section-text" strong style={{ color: '#3b82f6' }}>
                                            {poeValorComPontosEmMil(app_user.total_tickets)}
                                        </Text>
                                    </div>
                                </Col>

                                {app_user.social_institution_name && (
                                    <Col span={24}>
                                        <div style={{ display: 'flex', gap: 6, alignItems: 'center', flexWrap: 'wrap' }}>
                                            <Text type="secondary" className="section-label" style={{ fontSize: 12, color: isDark ? '#94a3b8' : '#64748b' }}>
                                                Instituição Beneficiada:
                                            </Text>
                                            <Text className="section-text" strong style={{ color: isDark ? '#f1f5f9' : '#0f172a' }}>
                                                {app_user.social_institution_name}
                                            </Text>
                                            {award.social_institution_value && Number(award.social_institution_value) > 0 ? (
                                                <Tag color="blue" style={{ borderRadius: 4, fontWeight: 700, fontSize: 11, margin: 0 }}>
                                                    R$ {convertMoedaBRDoJSNovo(award.social_institution_value)}
                                                </Tag>
                                            ) : null}
                                        </div>
                                    </Col>
                                )}

                                <Col xs={24} sm={12}>
                                    <div style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
                                        <Text type="secondary" className="section-label" style={{ fontSize: 12, color: isDark ? '#94a3b8' : '#64748b' }}>
                                            Notas válidas:
                                        </Text>
                                        <Text className="section-text" strong style={{ color: '#10b981' }}>
                                            {poeValorComPontosEmMil(app_user.total_invoices)}
                                        </Text>
                                    </div>
                                </Col>
                                <Col xs={24} sm={12}>
                                    <div style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
                                        <Text type="secondary" className="section-label" style={{ fontSize: 12, color: isDark ? '#94a3b8' : '#64748b' }}>
                                            Valor gasto:
                                        </Text>
                                        <Text className="section-text" strong style={{ color: '#10b981' }}>
                                            R$ {convertMoedaBRDoJSNovo(app_user.value_invoices)}
                                        </Text>
                                    </div>
                                </Col>
                            </Row>
                        ) : (
                            <Text type="secondary" style={{ color: isDark ? '#94a3b8' : '#64748b' }}>
                                Nenhum ganhador apurado ainda.
                            </Text>
                        )}
                    </Card>
                );
            })}
        </div>
    );
};
